"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateCouponCodeSfccSchema = void 0;
exports.CreateCouponCodeSfccSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    properties: {
        rmaCaseNumber: {
            type: 'string',
            minLength: 1,
        },
        messageId: {
            type: 'string',
            minLength: 1,
        },
        couponId: {
            type: 'string',
            minLength: 1,
        },
        userCountry: {
            type: 'string',
            minLength: 2,
        },
    },
    required: ['rmaCaseNumber', 'messageId', 'couponId', 'userCountry'],
    type: 'object',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3JlYXRlLWNvdXBvbi1jb2RlLXNmY2MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvZG9tcy9zY2hlbWFzL2NyZWF0ZS1jb3Vwb24tY29kZS1zZmNjLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsMEJBQTBCLEdBQUc7SUFDeEMsT0FBTyxFQUFFLHlDQUF5QztJQUNsRCxVQUFVLEVBQUU7UUFDVixhQUFhLEVBQUU7WUFDYixJQUFJLEVBQUUsUUFBUTtZQUNkLFNBQVMsRUFBRSxDQUFDO1NBQ2I7UUFDRCxTQUFTLEVBQUU7WUFDVCxJQUFJLEVBQUUsUUFBUTtZQUNkLFNBQVMsRUFBRSxDQUFDO1NBQ2I7UUFDRCxRQUFRLEVBQUU7WUFDUixJQUFJLEVBQUUsUUFBUTtZQUNkLFNBQVMsRUFBRSxDQUFDO1NBQ2I7UUFDRCxXQUFXLEVBQUU7WUFDWCxJQUFJLEVBQUUsUUFBUTtZQUNkLFNBQVMsRUFBRSxDQUFDO1NBQ2I7S0FDRjtJQUNELFFBQVEsRUFBRSxDQUFDLGVBQWUsRUFBRSxXQUFXLEVBQUUsVUFBVSxFQUFFLGFBQWEsQ0FBQztJQUNuRSxJQUFJLEVBQUUsUUFBUTtDQUNmLENBQUEiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgY29uc3QgQ3JlYXRlQ291cG9uQ29kZVNmY2NTY2hlbWEgPSB7XG4gICRzY2hlbWE6ICdodHRwOi8vanNvbi1zY2hlbWEub3JnL2RyYWZ0LTA3L3NjaGVtYSMnLFxuICBwcm9wZXJ0aWVzOiB7XG4gICAgcm1hQ2FzZU51bWJlcjoge1xuICAgICAgdHlwZTogJ3N0cmluZycsXG4gICAgICBtaW5MZW5ndGg6IDEsXG4gICAgfSxcbiAgICBtZXNzYWdlSWQ6IHtcbiAgICAgIHR5cGU6ICdzdHJpbmcnLFxuICAgICAgbWluTGVuZ3RoOiAxLFxuICAgIH0sXG4gICAgY291cG9uSWQ6IHtcbiAgICAgIHR5cGU6ICdzdHJpbmcnLFxuICAgICAgbWluTGVuZ3RoOiAxLFxuICAgIH0sXG4gICAgdXNlckNvdW50cnk6IHtcbiAgICAgIHR5cGU6ICdzdHJpbmcnLFxuICAgICAgbWluTGVuZ3RoOiAyLFxuICAgIH0sXG4gIH0sXG4gIHJlcXVpcmVkOiBbJ3JtYUNhc2VOdW1iZXInLCAnbWVzc2FnZUlkJywgJ2NvdXBvbklkJywgJ3VzZXJDb3VudHJ5J10sXG4gIHR5cGU6ICdvYmplY3QnLFxufVxuIl19